<div class="content-layout" [brightsideWebFb]="{event_name: 'helping hands welcome'}">
  <bw-action-article-legacy>
    <ui-nav-exit-back header-actions [trackingDetail]="{ event_name: 'helping_hands_welcome_dismissed' }"></ui-nav-exit-back>

    <div header-title>
      <typography-legacy title-large color="var(--primary-text)" class="mb-sm">
        {{ 'HH_INTRO_TITLE' | translate }}
      </typography-legacy>
    </div>
    <div content-section>
      <bw-paragraph-legacy>
        {{ 'HH_INTRO_SECTION1_DESC' | translate }}
      </bw-paragraph-legacy>
      <div class="flex mb-sm">
        <div class="flex-row">
          <bw-icon-legacy class="mr-xs" iconName="lightbulb" color="var(--brand)" backgroundColor="var(--bg-gray)"></bw-icon-legacy>
          <typography-legacy title-medium>
            {{ 'HH_INTRO_SECTION1_TITLE' | translate }}
          </typography-legacy>
        </div>
      </div>

      <typography-legacy text-medium-semibold class="mb-sm">
        {{ 'HH_FAQ_1' | translate }}
      </typography-legacy>
      <bw-paragraph-legacy>
        <div [innerHTML]="'HH_FAQ_1_DESC' | translate"></div>
      </bw-paragraph-legacy>

      <typography-legacy text-medium-semibold class="mb-sm">
        {{ 'HH_FAQ_2' | translate }}
      </typography-legacy>
      <bw-paragraph-legacy>
        <div [innerHTML]="'HH_FAQ_2_DESC' | translate"></div>
      </bw-paragraph-legacy>

      <typography-legacy text-medium-semibold class="mb-sm">
        {{ 'HH_FAQ_3' | translate }}
      </typography-legacy>
      <bw-paragraph-legacy>
        <div innerHTML="{{'HH_FAQ_3_DESC' | translate}}"></div>
      </bw-paragraph-legacy>
    </div>
    <button
      bw-button-legacy
      footer-actions
      [brightsideWebFb]="{event_name: 'helping hands welcome'}"
      (click)="openChat();">{{ 'MESSAGE_FA' | translate }}</button>
  </bw-action-article-legacy>
</div>
